'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' });

var HeadsetMic = function HeadsetMic(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

HeadsetMic = (0, _pure2.default)(HeadsetMic);
HeadsetMic.muiName = 'SvgIcon';

exports.default = HeadsetMic;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/HeadsetMic.js
// module id = 2482
// module chunks = 0